var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQueryTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 22,
    viewBox: "0 0 39 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0137 3.66602H7.30932C3.82478 3.66602 1 6.49079 1 9.97533V14.6797C1 18.1643 3.82478 20.989 7.30932 20.989H12.0137C15.4982 20.989 18.323 18.1643 18.323 14.6797V9.97533C18.323 6.49079 15.4982 3.66602 12.0137 3.66602Z",
    stroke: "#7B838C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66486 12.3302L13.2944 8.69336",
    stroke: "#7B838C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48814 13.243C9.8988 13.243 10.2317 12.9101 10.2317 12.4994C10.2317 12.0888 9.8988 11.7559 9.48814 11.7559C9.07748 11.7559 8.74457 12.0888 8.74457 12.4994C8.74457 12.9101 9.07748 13.243 9.48814 13.243Z",
    stroke: "#7B838C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66486 2.7669V1",
    stroke: "#7B838C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03137 1H11.2928",
    stroke: "#7B838C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7212 18.9711C37.4427 18.2864 37.8402 17.2631 37.6414 16.1514C37.3764 14.6422 35.985 13.582 34.4463 13.582H29.6462C28.0118 13.582 26.5541 14.7747 26.3922 16.4091C26.2155 18.279 27.6805 19.8472 29.5063 19.8472H34.2475C35.0132 20.4141 35.8672 20.7748 36.4414 20.9809C36.6844 21.0693 36.92 20.8411 36.8537 20.5907C36.7359 20.1343 36.6917 19.5453 36.7138 18.9711H36.7212Z",
    stroke: "#7B838C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1238 9.05507C23.4023 8.3704 23.0047 7.34706 23.2035 6.23539C23.4685 4.72616 24.86 3.66602 26.3986 3.66602H31.1987C32.8331 3.66602 34.2908 4.85868 34.4528 6.49306C34.6295 8.36303 33.1644 9.93116 31.3386 9.93116H26.5974C25.8318 10.498 24.9778 10.8588 24.4035 11.0649C24.1606 11.1533 23.925 10.925 23.9912 10.6747C24.109 10.2183 24.1532 9.62931 24.1311 9.05507H24.1238Z",
    stroke: "#7B838C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueryTime);
export default __webpack_public_path__ + "static/media/QueryTime.09b0e447a8e6b859dee3ef7b7df7330d.svg";
export { ForwardRef as ReactComponent };